import _ from "lodash";
import contactDetails from "../../constants/contactDetails.json";
// Import Actions
import {
    SET_NETWORK_STATUS,
    BACK_BUTTON_VISIBILITY_STATUS,
    SET_AUTH_VIEW,
    REQUEST_LOGIN,
    REQUEST_OTP_LOGIN,
    REQUEST_OTP_FAILURE,
    REQUEST_OTP_SUCCESS,
    LOGIN_OTP_SUCCESS,
    LOGIN_OTP_FAILURE,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    REQUEST_LOGOUT,
    LOGOUT_SUCCESS,
    REQUEST_CHECK_TOKEN,
    TOKEN_VALID,
    TOKEN_INVALID,
    EDIT_USER_INFO,
    EDITING_USER_INFO,
    VERIFYING_OTP,
    CLOSE_EDIT_USER_INFO,
    UPDATE_USER_INFO_STATE,
    CONTACT_SUBMITTING_DATA,
    LOADING_CAREERS_PAGE,
    LOAD_CAREERS_PAGE,
    FETCHING_PAGEDATA,
    FETCH_PAGEDATA,
    REQUEST_REGISTER,
    REGISTER_SUCCESS,
    REGISTER_FAILURE,
    RESET_REGISTER,
    PAGE_NOT_FOUND,
    PAGE_REDIRECT,
    SET_HOME_PAGE_FOOTER,
    LOAD_CITY_LIST,
    TOGGLE_CORPORATE_PAGE_HEADER,
    TOGGLE_LEAD_SUBMITTING,
    CORPORATE_USER_REGISTER_STATUS,
    SET_LOGIN_OTP_FAILURE,
    REGISTER_PAUSE,
    RESET_LOGIN_OTP_FAILURE,
    LOGIN_SUCCESS_MODAL,
    REGISTER_SUCCESS_MODAL,
    RESEND_LOGIN_OTP,
    REQUEST_OTP_SUCCESS_MOBILE,
    REQUEST_OTP_FAILURE_MOBILE,
    ADDING_USER_LOCATION,
    LOGIN_REDIRECTION_URL,
    IS_ADS_BANNER_VISIBLE
} from "../actions/AppActions";

// Initial State
const initialState = {
    isDrawerModalVisible: false,
    isPageNotFound: false,
    isPageRedirect: false,
    redirectUrl: "",
    redirectStatus: "",
    cities: [],
    userCurrentCity : {},
    occasions: [],
    budget_range: [],
    guest_range: [],
    package_details: [],
    selectedCity: "",
    isAuthenticated: false,
    isOTPSent: false,
    isRegisterOTPSent: false,
    isRequestingOtp: false,
    isFetching: false,
    isVerifying: false,
    _refurl: "",
    message: "",
    isLoginOtpFailure: false,
    user: {},
    isLoading: false,
    isEditingUserInfo: false,
    isRegistering: false,
    isSubmitting: false,
    jobs: [],
    isFetchingJobs: false,
    isFetchingPagedata: false,
    pagedata: {},
    nation: {},
    isFooterBelowVisible: false,
    isBackButtonVisible: true,
    countryCodeDict: {},
    isOtpVerified: false,
    loginRedirectionUrl : null,
    corporatepagedata: {
        realevents: [
            {
                _id: "5cf276cace2ec75cd849ee1f",
                feedback_id: "",
                images: [
                    "5cf2791cce2ec75cd849ee48",
                    "5cf2791cce2ec75cd849ee43",
                    "5cf2791cce2ec75cd849ee44",
                    "5cf2791cce2ec75cd849ee45",
                    "5cf2791cce2ec75cd849ee46",
                    "5cf2791cce2ec75cd849ee47",
                    "5cf27920ce2ec75cd849ee49",
                    "5cf27921ce2ec75cd849ee4a",
                    "5cf27923ce2ec75cd849ee4b",
                    "5cf27924ce2ec75cd849ee4c",
                    "5cf27925ce2ec75cd849ee4d",
                    "5cf27925ce2ec75cd849ee4e",
                    "5cf27965ce2ec75cd849ee4f",
                    "5cf2796dce2ec75cd849ee50",
                    "5cf2796fce2ec75cd849ee51",
                    "5cf27972ce2ec75cd849ee52",
                    "5cf27972ce2ec75cd849ee53",
                    "5cf27973ce2ec75cd849ee54",
                    "5cf27973ce2ec75cd849ee55",
                    "5cf27974ce2ec75cd849ee56",
                    "5cf27976ce2ec75cd849ee57",
                    "5cf27979ce2ec75cd849ee59",
                    "5cf27978ce2ec75cd849ee58",
                    "5cf2797ace2ec75cd849ee5a",
                    "5cf279b1ce2ec75cd849ee5f",
                    "5cf279bace2ec75cd849ee61",
                    "5cf279bace2ec75cd849ee60",
                    "5cf279bace2ec75cd849ee62",
                    "5cf279bace2ec75cd849ee63",
                    "5cf279bace2ec75cd849ee64",
                    "5cf279bfce2ec75cd849ee65",
                    "5cf279c8ce2ec75cd849ee66",
                    "5cf279c9ce2ec75cd849ee67",
                    "5cf279c9ce2ec75cd849ee68",
                    "5cf279ccce2ec75cd849ee69",
                    "5cf279ccce2ec75cd849ee6a",
                    "5cf27a0dce2ec75cd849ee77",
                    "5cf27a18ce2ec75cd849ee7b",
                    "5cf27a18ce2ec75cd849ee7c",
                    "5cf27a15ce2ec75cd849ee7a",
                    "5cf27a1cce2ec75cd849ee80",
                    "5cf27a18ce2ec75cd849ee7d",
                    "5cf27a1cce2ec75cd849ee7f",
                    "5cf27a1ece2ec75cd849ee81",
                    "5cf27a1ece2ec75cd849ee82",
                    "5cf27a1fce2ec75cd849ee83",
                    "5cf27a20ce2ec75cd849ee84",
                    "5cf27a20ce2ec75cd849ee85",
                    "5cf27a58ce2ec75cd849ee93",
                    "5cf27a58ce2ec75cd849ee91",
                    "5cf27a58ce2ec75cd849ee96",
                    "5cf27a58ce2ec75cd849ee94",
                    "5cf27a58ce2ec75cd849ee92",
                    "5cf27a58ce2ec75cd849ee95",
                    "5cf27a61ce2ec75cd849ee97",
                    "5cf27a64ce2ec75cd849ee98",
                    "5cf27a65ce2ec75cd849ee99",
                    "5cf27a65ce2ec75cd849ee9a",
                    "5cf27a66ce2ec75cd849ee9c",
                    "5cf27a66ce2ec75cd849ee9b",
                    "5cf27aa1ce2ec75cd849ee9d",
                    "5cf27aa3ce2ec75cd849ee9e",
                    "5cf27aa4ce2ec75cd849ee9f",
                    "5cf27aa4ce2ec75cd849eea0",
                    "5cf27aadce2ec75cd849eea2",
                    "5cf27aadce2ec75cd849eea7",
                    "5cf27aadce2ec75cd849eea1",
                    "5cf27aadce2ec75cd849eea4",
                    "5cf27aafce2ec75cd849eeaa",
                    "5cf27aafce2ec75cd849eea9",
                    "5cf27ab0ce2ec75cd849eeab",
                    "5cf27ab1ce2ec75cd849eeac",
                    "5cf27af3ce2ec75cd849eead",
                    "5cf27af5ce2ec75cd849eeb0",
                    "5cf27af8ce2ec75cd849eeb1",
                    "5cf27af3ce2ec75cd849eeaf",
                    "5cf27af3ce2ec75cd849eeae",
                    "5cf27afbce2ec75cd849eeb2",
                    "5cf27afdce2ec75cd849eeb5",
                    "5cf27afdce2ec75cd849eeb3",
                    "5cf27afdce2ec75cd849eeb4",
                    "5cf27affce2ec75cd849eeb7",
                    "5cf27affce2ec75cd849eeb8",
                    "5cf27affce2ec75cd849eeb6",
                    "5cf27b2cce2ec75cd849eeb9",
                    "5cf27b33ce2ec75cd849eebd",
                    "5cf27b33ce2ec75cd849eebb",
                    "5cf27b33ce2ec75cd849eeba",
                    "5cf27b33ce2ec75cd849eebc",
                    "5cf27b3ace2ec75cd849eebe",
                    "5cf27b3dce2ec75cd849eec0",
                    "5cf27b3dce2ec75cd849eebf",
                    "5cf27b40ce2ec75cd849eec3",
                    "5cf27b40ce2ec75cd849eec1",
                    "5cf27b40ce2ec75cd849eec2",
                    "5cf27b42ce2ec75cd849eec4",
                    "5cf27b76ce2ec75cd849eec9",
                    "5cf27b7bce2ec75cd849eeca",
                    "5cf27b7cce2ec75cd849eecc",
                    "5cf27b7cce2ec75cd849eecd",
                    "5cf27b7cce2ec75cd849eecb",
                    "5cf27b7cce2ec75cd849eece",
                    "5cf27b7cce2ec75cd849eecf",
                    "5cf27b7dce2ec75cd849eed0",
                    "5cf27b83ce2ec75cd849eed7",
                    "5cf27b83ce2ec75cd849eed6",
                    "5cf27b83ce2ec75cd849eed5",
                    "5cf27b87ce2ec75cd849eed8",
                    "5cf27bb6ce2ec75cd849eedc",
                    "5cf27bb9ce2ec75cd849eedd",
                    "5cf27bb9ce2ec75cd849eede",
                    "5cf27bbdce2ec75cd849eedf",
                    "5cf27bc2ce2ec75cd849eee4",
                    "5cf27bc2ce2ec75cd849eee3",
                    "5cf27bc2ce2ec75cd849eee2",
                    "5cf27bc2ce2ec75cd849eee1",
                    "5cf27bbfce2ec75cd849eee0",
                    "5cf27bc4ce2ec75cd849eee6",
                    "5cf27bc4ce2ec75cd849eee5",
                    "5cf27bc5ce2ec75cd849eee7",
                    "5cf27bf3ce2ec75cd849eee9",
                    "5cf27bf3ce2ec75cd849eee8",
                    "5cf27bf3ce2ec75cd849eeea",
                    "5cf27bfcce2ec75cd849eeeb",
                    "5cf27c03ce2ec75cd849eeec",
                    "5cf27c03ce2ec75cd849eeed",
                    "5cf27c0dce2ec75cd849eef0",
                    "5cf27c0cce2ec75cd849eeef",
                    "5cf27c0cce2ec75cd849eeee",
                    "5cf27c0fce2ec75cd849eef1",
                    "5cf27c10ce2ec75cd849eef3",
                    "5cf27c10ce2ec75cd849eef2",
                    "5cf27c4ace2ec75cd849eefd",
                    "5cf27c46ce2ec75cd849eefc",
                    "5cf27c4ace2ec75cd849eefe",
                    "5cf27c5ace2ec75cd849ef02",
                    "5cf27c5ece2ec75cd849ef05",
                    "5cf27c54ce2ec75cd849eeff",
                    "5cf27c54ce2ec75cd849ef00",
                    "5cf27c54ce2ec75cd849ef01",
                    "5cf27c5ace2ec75cd849ef03",
                    "5cf27c5ace2ec75cd849ef04",
                    "5cf27c5ece2ec75cd849ef06",
                    "5cf27c5ece2ec75cd849ef07",
                    "5cf27c9cce2ec75cd849ef0a",
                    "5cf27c9cce2ec75cd849ef0e",
                    "5cf27c9cce2ec75cd849ef0b",
                    "5cf27c9cce2ec75cd849ef0d",
                    "5cf27c9cce2ec75cd849ef10",
                    "5cf27c9cce2ec75cd849ef0f",
                    "5cf27c9cce2ec75cd849ef0c",
                    "5cf27ca4ce2ec75cd849ef14",
                    "5cf27c9cce2ec75cd849ef11",
                    "5cf27caace2ec75cd849ef17",
                    "5cf27caace2ec75cd849ef16",
                    "5cf27caace2ec75cd849ef18",
                    "5cf27cddce2ec75cd849ef23",
                    "5cf27ce7ce2ec75cd849ef2a",
                    "5cf27ce7ce2ec75cd849ef27",
                    "5cf27ce7ce2ec75cd849ef29",
                    "5cf27ce7ce2ec75cd849ef28",
                    "5cf27ce7ce2ec75cd849ef26",
                    "5cf27ce7ce2ec75cd849ef24",
                    "5cf27ce7ce2ec75cd849ef25",
                    "5cf27cf3ce2ec75cd849ef2e",
                    "5cf27cf3ce2ec75cd849ef2d",
                    "5cf27ceece2ec75cd849ef2b",
                    "5cf27ceece2ec75cd849ef2c",
                    "5cf27d24ce2ec75cd849ef40",
                    "5cf27d25ce2ec75cd849ef41",
                    "5cf27d26ce2ec75cd849ef43",
                    "5cf27d27ce2ec75cd849ef44",
                    "5cf27d25ce2ec75cd849ef42",
                    "5cf27d2cce2ec75cd849ef45",
                    "5cf27d2ece2ec75cd849ef47",
                    "5cf27d31ce2ec75cd849ef48",
                    "5cf27d31ce2ec75cd849ef49",
                    "5cf27d2cce2ec75cd849ef46",
                    "5cf27d31ce2ec75cd849ef4b",
                    "5cf27d31ce2ec75cd849ef4a",
                    "5cf27d86ce2ec75cd849ef4d",
                    "5cf27d86ce2ec75cd849ef4c",
                    "5cf27d8cce2ec75cd849ef4f",
                    "5cf27d8bce2ec75cd849ef4e",
                    "5cf27d8cce2ec75cd849ef50",
                    "5cf27d8dce2ec75cd849ef51",
                    "5cf27d90ce2ec75cd849ef52",
                    "5cf27d91ce2ec75cd849ef53",
                    "5cf27d94ce2ec75cd849ef55",
                    "5cf27d95ce2ec75cd849ef56",
                    "5cf27d94ce2ec75cd849ef54",
                    "5cf27d96ce2ec75cd849ef57",
                    "5cf27dc4ce2ec75cd849ef5f",
                    "5cf27dc3ce2ec75cd849ef5d",
                    "5cf27dc4ce2ec75cd849ef5e",
                    "5cf27dc9ce2ec75cd849ef62",
                    "5cf27dc8ce2ec75cd849ef60",
                    "5cf27dc8ce2ec75cd849ef61",
                    "5cf27dd3ce2ec75cd849ef63",
                    "5cf27dd5ce2ec75cd849ef64",
                    "5cf27dd5ce2ec75cd849ef65",
                    "5cf27dd6ce2ec75cd849ef67",
                    "5cf27dd6ce2ec75cd849ef66",
                    "5cf27dd7ce2ec75cd849ef68",
                    "5cf27e04ce2ec75cd849ef69",
                    "5cf27e09ce2ec75cd849ef6a",
                    "5cf27e0ece2ec75cd849ef6e",
                    "5cf27e0ace2ec75cd849ef6d",
                    "5cf27e0ace2ec75cd849ef6c",
                    "5cf27e09ce2ec75cd849ef6b",
                    "5cf27e11ce2ec75cd849ef70",
                    "5cf27e16ce2ec75cd849ef72",
                    "5cf27e11ce2ec75cd849ef6f",
                    "5cf27e16ce2ec75cd849ef73",
                    "5cf27e11ce2ec75cd849ef71",
                    "5cf27e16ce2ec75cd849ef74",
                    "5cf27e52ce2ec75cd849ef7a",
                    "5cf27e52ce2ec75cd849ef76",
                    "5cf27e52ce2ec75cd849ef77",
                    "5cf27e51ce2ec75cd849ef75",
                    "5cf27e52ce2ec75cd849ef78",
                    "5cf27e52ce2ec75cd849ef79",
                    "5cf27e55ce2ec75cd849ef80",
                    "5cf27e55ce2ec75cd849ef81",
                    "5cf27e5cce2ec75cd849ef82",
                    "5cf27e5cce2ec75cd849ef83",
                    "5cf27e5dce2ec75cd849ef85",
                    "5cf27e5dce2ec75cd849ef84",
                    "5cf27e98ce2ec75cd849ef87",
                    "5cf27e8fce2ec75cd849ef86",
                    "5cf27e98ce2ec75cd849ef88",
                    "5cf27e9ece2ec75cd849ef89",
                    "5cf27ea3ce2ec75cd849ef8a",
                    "5cf27ea5ce2ec75cd849ef8c",
                    "5cf27ea5ce2ec75cd849ef8b",
                    "5cf27ea7ce2ec75cd849ef8d",
                    "5cf27ea7ce2ec75cd849ef8f",
                    "5cf27ea7ce2ec75cd849ef8e",
                    "5cf27eaace2ec75cd849ef90",
                    "5cf27eabce2ec75cd849ef91",
                    "5cf27f08ce2ec75cd849ef92",
                    "5cf27f0bce2ec75cd849ef93",
                    "5cf27f0cce2ec75cd849ef94",
                    "5cf27f0fce2ec75cd849ef96",
                    "5cf27f0fce2ec75cd849ef95",
                    "5cf27f11ce2ec75cd849ef97",
                    "5cf27f13ce2ec75cd849ef98",
                    "5cf27f15ce2ec75cd849ef99",
                    "5cf27f16ce2ec75cd849ef9a",
                    "5cf27f16ce2ec75cd849ef9b",
                    "5cf27f17ce2ec75cd849ef9c",
                    "5cf27f18ce2ec75cd849ef9d",
                    "5cf27f47ce2ec75cd849ef9f",
                    "5cf27f47ce2ec75cd849ef9e",
                    "5cf27f48ce2ec75cd849efa1",
                    "5cf27f47ce2ec75cd849efa0",
                    "5cf27f50ce2ec75cd849efa2",
                    "5cf27f50ce2ec75cd849efa3",
                    "5cf27f51ce2ec75cd849efa4",
                    "5cf27f51ce2ec75cd849efa5",
                    "5cf27f58ce2ec75cd849efa7",
                    "5cf27f58ce2ec75cd849efa6",
                    "5cf27f59ce2ec75cd849efa9",
                    "5cf27f58ce2ec75cd849efa8",
                    "5cf27f8bce2ec75cd849efab",
                    "5cf27f8bce2ec75cd849efaa",
                    "5cf27f8dce2ec75cd849efac",
                    "5cf27f92ce2ec75cd849efad",
                    "5cf27f93ce2ec75cd849efae",
                    "5cf27f93ce2ec75cd849efaf",
                    "5cf27f97ce2ec75cd849efb1",
                    "5cf27f96ce2ec75cd849efb0",
                    "5cf27f99ce2ec75cd849efb2",
                    "5cf27f9bce2ec75cd849efb4",
                    "5cf27f9bce2ec75cd849efb3",
                    "5cf27f9bce2ec75cd849efb5",
                    "5cf27fe1ce2ec75cd849efb9",
                    "5cf27fe5ce2ec75cd849efba",
                    "5cf27fe5ce2ec75cd849efbb",
                    "5cf27fe9ce2ec75cd849efbc",
                    "5cf27feace2ec75cd849efbd",
                    "5cf27fedce2ec75cd849efbe",
                    "5cf27feece2ec75cd849efbf",
                    "5cf27ff0ce2ec75cd849efc0",
                    "5cf27ff1ce2ec75cd849efc1",
                    "5cf27ff1ce2ec75cd849efc3",
                    "5cf27ff1ce2ec75cd849efc2",
                    "5cf27ff2ce2ec75cd849efc4",
                    "5cf2802ace2ec75cd849efc5",
                    "5cf2802dce2ec75cd849efc7",
                    "5cf2802ace2ec75cd849efc6",
                    "5cf28038ce2ec75cd849efcb",
                    "5cf28038ce2ec75cd849efcd",
                    "5cf28038ce2ec75cd849efcc",
                    "5cf2803dce2ec75cd849efd0",
                    "5cf2802dce2ec75cd849efc8",
                    "5cf28038ce2ec75cd849efce",
                    "5cf2803dce2ec75cd849efcf",
                    "5cf2802dce2ec75cd849efca",
                    "5cf2802dce2ec75cd849efc9",
                    "5cf2807dce2ec75cd849efd3",
                    "5cf2807dce2ec75cd849efd2",
                    "5cf2807ece2ec75cd849efd5",
                    "5cf2807dce2ec75cd849efd1",
                    "5cf2807dce2ec75cd849efd4",
                    "5cf28081ce2ec75cd849efd6",
                    "5cf28081ce2ec75cd849efd7",
                    "5cf28084ce2ec75cd849efd9",
                    "5cf28084ce2ec75cd849efd8",
                    "5cf28086ce2ec75cd849efdc",
                    "5cf28086ce2ec75cd849efda",
                    "5cf28086ce2ec75cd849efdb",
                    "5cf280ccce2ec75cd849efde",
                    "5cf280c5ce2ec75cd849efdd",
                    "5cf280d0ce2ec75cd849efdf",
                    "5cf280d1ce2ec75cd849efe0",
                    "5cf280d1ce2ec75cd849efe1",
                    "5cf280d3ce2ec75cd849efe2",
                    "5cf280d5ce2ec75cd849efe3",
                    "5cf280d6ce2ec75cd849efe4",
                    "5cf280d7ce2ec75cd849efe5",
                    "5cf280d9ce2ec75cd849efe6",
                    "5cf280dace2ec75cd849efe8",
                    "5cf280d9ce2ec75cd849efe7",
                    "5cf28106ce2ec75cd849efe9",
                    "5cf2810fce2ec75cd849efea",
                    "5cf2810fce2ec75cd849efec",
                    "5cf2810fce2ec75cd849efeb",
                    "5cf2810fce2ec75cd849efed",
                    "5cf28116ce2ec75cd849efef",
                    "5cf2810fce2ec75cd849efee",
                    "5cf28123ce2ec75cd849eff3",
                    "5cf28123ce2ec75cd849eff2",
                    "5cf28123ce2ec75cd849eff0",
                    "5cf28123ce2ec75cd849eff4",
                    "5cf28123ce2ec75cd849eff1",
                    "5cf28154ce2ec75cd849eff7",
                    "5cf28153ce2ec75cd849eff6",
                    "5cf28153ce2ec75cd849eff5",
                    "5cf2815ace2ec75cd849eff8",
                    "5cf2815ace2ec75cd849eff9",
                    "5cf28161ce2ec75cd849effd",
                    "5cf2815ace2ec75cd849effc",
                    "5cf2815ace2ec75cd849effb",
                    "5cf2815ace2ec75cd849effa",
                    "5cf28163ce2ec75cd849f000",
                    "5cf28163ce2ec75cd849effe",
                    "5cf28163ce2ec75cd849efff",
                    "5cf281a6ce2ec75cd849f001",
                    "5cf281aace2ec75cd849f002",
                    "5cf281abce2ec75cd849f003",
                    "5cf281acce2ec75cd849f004",
                    "5cf281acce2ec75cd849f005",
                    "5cf281b1ce2ec75cd849f006",
                    "5cf281b2ce2ec75cd849f007",
                    "5cf281b4ce2ec75cd849f008",
                    "5cf281b5ce2ec75cd849f00a",
                    "5cf281b5ce2ec75cd849f00b",
                    "5cf281b5ce2ec75cd849f009",
                    "5cf281b6ce2ec75cd849f00c",
                    "5cf281eece2ec75cd849f016",
                    "5cf281f4ce2ec75cd849f018",
                    "5cf281efce2ec75cd849f017",
                    "5cf281f4ce2ec75cd849f019",
                    "5cf281f4ce2ec75cd849f01a",
                    "5cf281fcce2ec75cd849f01d",
                    "5cf281fcce2ec75cd849f01f",
                    "5cf281fcce2ec75cd849f020",
                    "5cf281fcce2ec75cd849f01e",
                    "5cf281f4ce2ec75cd849f01b",
                    "5cf281f7ce2ec75cd849f01c",
                    "5cf281fcce2ec75cd849f021",
                    "5cf28247ce2ec75cd849f02a",
                    "5cf2823cce2ec75cd849f022",
                    "5cf2823dce2ec75cd849f025",
                    "5cf2823cce2ec75cd849f023",
                    "5cf2823cce2ec75cd849f024",
                    "5cf2824fce2ec75cd849f02b",
                    "5cf28256ce2ec75cd849f02c",
                    "5cf28259ce2ec75cd849f02d",
                    "5cf2825dce2ec75cd849f02e",
                    "5cf28260ce2ec75cd849f031",
                    "5cf28260ce2ec75cd849f030",
                    "5cf28260ce2ec75cd849f032",
                    "5cf28260ce2ec75cd849f02f",
                ],
                primaryImages: [
                    {
                        _id: "5cf28123ce2ec75cd849eff3",
                        tags: [],
                        name: "pathways-corporate-party-at-southpoint-carnival-huy4x",
                        baseUrl: "pathways-corporate-party-at-southpoint-carnival",
                    },
                    {
                        _id: "5cf2810fce2ec75cd849efee",
                        tags: [],
                        name: "pathways-corporate-party-at-southpoint-carnival-9l6hd",
                        baseUrl: "pathways-corporate-party-at-southpoint-carnival",
                    },
                    {
                        _id: "5cf27f17ce2ec75cd849ef9c",
                        tags: [],
                        name: "pathways-corporate-party-at-southpoint-carnival-07wc9",
                        baseUrl: "pathways-corporate-party-at-southpoint-carnival",
                    },
                ],
                isApproved: true,
                infoComplete: 0,
                uploadCount: 278,
                event_id: "",
                url: "pathways-corporate-party-at-southpoint-carnival",
                venue_id: "5aa911b8b78e580019e45c3c",
                venue_name: "Southpoint Carnival",
                event_name: "Pathways Corporate Party",
                customer_name: "Meeta Johri",
                color: [
                    {
                        _id: "5af3d642d406dc0053263dac",
                        name: "Red",
                        code: "#C00707",
                    },
                    {
                        _id: "5af3d62bd406dc0053263dab",
                        name: "White",
                        code: "#F3F3F3",
                    },
                    {
                        _id: "5af3d680d406dc0053263dad",
                        name: "Yellow",
                        code: "#F1F40E",
                    },
                ],
                customer_review: "",
                description: "",
                event_date: "2019-05-30T18:30:00.000Z",
                event_time: "Dinner",
                event_type: "Corporate Party",
                guests: 256,
                name: "Pathways Corporate Party",
                city: "gurgaon",
                loc: {
                    long: 77.0990132,
                    lat: 28.4481452,
                },
                subArea: "Golf Course Road",
                venue_address: "1st Floor, Southpoint Mall, Golf Course Road, Gurgaon.",
                venue_type: "Bar and Pub",
                vendor_address: "",
                vendor_name: "",
                publicImageCount: 383,
            },
            {
                _id: "5ce674ed7786fd16912fd0f5",
                feedback_id: "",
                images: [
                    "5ce6896e7786fd16912fd185",
                    "5ce689707786fd16912fd186",
                    "5ce689787786fd16912fd18c",
                    "5ce689807786fd16912fd18d",
                    "5ce689897786fd16912fd192",
                    "5ce6898f7786fd16912fd198",
                    "5ce689927786fd16912fd199",
                    "5ce689937786fd16912fd19a",
                    "5ce68a0b7786fd16912fd1a2",
                    "5ce68a107786fd16912fd1a4",
                    "5ce68a107786fd16912fd1a3",
                    "5ce68a1b7786fd16912fd1a5",
                    "5ce68a247786fd16912fd1a6",
                    "5ce68a3c7786fd16912fd1a7",
                    "5ce68a507786fd16912fd1ac",
                    "5ce68a697786fd16912fd1ad",
                    "5ce68ab87786fd16912fd1b2",
                    "5ce68adc7786fd16912fd1b3",
                    "5ce68ae97786fd16912fd1b4",
                    "5ce68afa7786fd16912fd1b9",
                    "5ce68b097786fd16912fd1ba",
                    "5ce68b0b7786fd16912fd1bb",
                    "5ce68b0f7786fd16912fd1bc",
                    "5ce68b117786fd16912fd1bd",
                    "5ce68b137786fd16912fd1be",
                    "5ce68b147786fd16912fd1bf",
                    "5ce68b687786fd16912fd1c6",
                    "5ce68b717786fd16912fd1c7",
                    "5ce68b787786fd16912fd1c8",
                    "5ce68b7a7786fd16912fd1ca",
                    "5ce68b7a7786fd16912fd1c9",
                    "5ce68b807786fd16912fd1cb",
                    "5ce68b857786fd16912fd1cc",
                    "5ce68b877786fd16912fd1cd",
                    "5ce68b927786fd16912fd1ce",
                    "5ce68b927786fd16912fd1cf",
                    "5ce68b927786fd16912fd1d0",
                    "5ce68b937786fd16912fd1d1",
                    "5ce68bf37786fd16912fd1d2",
                    "5ce68bf77786fd16912fd1d3",
                    "5ce68bfb7786fd16912fd1d4",
                    "5ce68c037786fd16912fd1d5",
                    "5ce68c057786fd16912fd1d6",
                    "5ce68c0b7786fd16912fd1d7",
                    "5ce68c0e7786fd16912fd1d8",
                    "5ce68c177786fd16912fd1d9",
                    "5ce68c217786fd16912fd1da",
                    "5ce68c217786fd16912fd1db",
                ],
                primaryImages: [
                    {
                        _id: "5ce68a247786fd16912fd1a6",
                        tags: [],
                        name: "cardekho-corporate-party-at--m5xg8",
                        baseUrl: "cardekho-corporate-party-at-",
                    },
                    {
                        _id: "5ce68c0e7786fd16912fd1d8",
                        tags: [],
                        name: "cardekho-corporate-party-at--hlbbm",
                        baseUrl: "cardekho-corporate-party-at-",
                    },
                    {
                        _id: "5ce68b937786fd16912fd1d1",
                        tags: [],
                        name: "cardekho-corporate-party-at--dcayh",
                        baseUrl: "cardekho-corporate-party-at-",
                    },
                ],
                isApproved: true,
                infoComplete: 0,
                uploadCount: 48,
                event_id: "",
                url: "cardekho-corporate-party-at-",
                venue_id: "5b716f8817060300d72e7c6b",
                venue_name: "Pra Pra Prank",
                event_name: "Cardekho Corporate Party",
                customer_name: "Priyanka",
                color: [
                    {
                        _id: "5af3d6a5d406dc0053263dae",
                        name: "Black",
                        code: "#333333",
                    },
                    {
                        _id: "5af3d4f6d406dc0053263da9",
                        name: "Blue",
                        code: "#1664c4",
                    },
                    {
                        _id: "5af3d94fd406dc0053263dca",
                        name: "Golden",
                        code: "#E1B228",
                    },
                ],
                customer_review: "",
                description: "",
                event_date: "2019-05-21T18:30:00.000Z",
                event_time: "Dinner",
                event_type: "Corporate Party",
                guests: 15,
                name: "Cardekho Corporate Party",
                city: "gurgaon",
                loc: {
                    long: 77.0880104,
                    lat: 28.4948006,
                },
                subArea: "DLF Cyber City",
                venue_address:
                    "Shop 24, Ground Floor, Cyber Hub, Sector 24, DLF Cyber City, Gurgaon.",
                venue_type: "Restaurant",
                vendor_address: "",
                vendor_name: "",
                publicImageCount: 47,
            },
            {
                _id: "5ce27b1622035d4c3d05bf05",
                feedback_id: "",
                images: [
                    "5ce27e3b22035d4c3d05bf36",
                    "5ce27e3b22035d4c3d05bf34",
                    "5ce27e3b22035d4c3d05bf35",
                    "5ce27e4222035d4c3d05bf37",
                    "5ce27e4522035d4c3d05bf38",
                    "5ce27e4622035d4c3d05bf39",
                    "5ce27e4722035d4c3d05bf3a",
                    "5ce27e4822035d4c3d05bf3b",
                    "5ce27e4922035d4c3d05bf3c",
                    "5ce27e4922035d4c3d05bf3d",
                    "5ce27e4e22035d4c3d05bf3e",
                    "5ce27e4f22035d4c3d05bf3f",
                    "5ce27e5022035d4c3d05bf40",
                    "5ce27e5122035d4c3d05bf41",
                    "5ce27e5122035d4c3d05bf42",
                    "5ce27e5222035d4c3d05bf43",
                    "5ce27e7922035d4c3d05bf45",
                    "5ce27e7e22035d4c3d05bf47",
                    "5ce27e7e22035d4c3d05bf48",
                    "5ce27e8022035d4c3d05bf4a",
                    "5ce27e8522035d4c3d05bf4b",
                    "5ce27e8922035d4c3d05bf50",
                    "5ce27e8d22035d4c3d05bf51",
                    "5ce27e9e22035d4c3d05bf52",
                    "5ce27e9f22035d4c3d05bf53",
                    "5ce27ea122035d4c3d05bf54",
                    "5ce27ea322035d4c3d05bf55",
                    "5ce27ea422035d4c3d05bf56",
                    "5ce27ea522035d4c3d05bf57",
                    "5ce27ea622035d4c3d05bf58",
                    "5ce27ea722035d4c3d05bf59",
                    "5ce27f0322035d4c3d05bf5c",
                    "5ce27f0222035d4c3d05bf5a",
                    "5ce27f0322035d4c3d05bf5b",
                    "5ce27f0422035d4c3d05bf5d",
                    "5ce27f0b22035d4c3d05bf5e",
                    "5ce27f0f22035d4c3d05bf5f",
                    "5ce27f2022035d4c3d05bf60",
                    "5ce27f2422035d4c3d05bf61",
                    "5ce27f2422035d4c3d05bf62",
                    "5ce27f2622035d4c3d05bf63",
                    "5ce27f2c22035d4c3d05bf64",
                    "5ce27f2d22035d4c3d05bf65",
                    "5ce27f2e22035d4c3d05bf66",
                    "5ce27f3022035d4c3d05bf68",
                    "5ce27f3122035d4c3d05bf69",
                    "5ce27f3022035d4c3d05bf67",
                    "5ce27f5822035d4c3d05bf6a",
                    "5ce27f5a22035d4c3d05bf6c",
                    "5ce27f5a22035d4c3d05bf6b",
                    "5ce27f5c22035d4c3d05bf6e",
                    "5ce27f5c22035d4c3d05bf6d",
                    "5ce27f6322035d4c3d05bf6f",
                    "5ce27f6522035d4c3d05bf70",
                    "5ce27f6822035d4c3d05bf71",
                    "5ce27f6922035d4c3d05bf72",
                    "5ce27f6922035d4c3d05bf73",
                    "5ce27f6a22035d4c3d05bf74",
                    "5ce27f7022035d4c3d05bf76",
                    "5ce27f7122035d4c3d05bf77",
                    "5ce27f7022035d4c3d05bf75",
                    "5ce27f7122035d4c3d05bf78",
                    "5ce27f7222035d4c3d05bf79",
                    "5ce27fde22035d4c3d05bf7a",
                    "5ce27fe022035d4c3d05bf7b",
                    "5ce27fe422035d4c3d05bf7c",
                    "5ce27fe522035d4c3d05bf7d",
                    "5ce27fe522035d4c3d05bf7e",
                    "5ce27fe622035d4c3d05bf7f",
                    "5ce27fe722035d4c3d05bf80",
                    "5ce27fea22035d4c3d05bf81",
                    "5ce27fee22035d4c3d05bf83",
                    "5ce27fef22035d4c3d05bf84",
                    "5ce27fee22035d4c3d05bf82",
                    "5ce27ff022035d4c3d05bf86",
                    "5ce27fef22035d4c3d05bf85",
                    "5ce27ff122035d4c3d05bf87",
                    "5ce27ff322035d4c3d05bf88",
                    "5ce27ff422035d4c3d05bf89",
                    "5ce2801b22035d4c3d05bf8b",
                    "5ce2801b22035d4c3d05bf8a",
                    "5ce2801c22035d4c3d05bf8c",
                    "5ce2801d22035d4c3d05bf8e",
                    "5ce2801d22035d4c3d05bf8d",
                    "5ce2801f22035d4c3d05bf8f",
                    "5ce2802322035d4c3d05bf90",
                    "5ce2802522035d4c3d05bf91",
                    "5ce2802522035d4c3d05bf93",
                    "5ce2802522035d4c3d05bf92",
                    "5ce2802722035d4c3d05bf94",
                    "5ce2802a22035d4c3d05bf96",
                    "5ce2802a22035d4c3d05bf95",
                    "5ce2802b22035d4c3d05bf98",
                    "5ce2802b22035d4c3d05bf99",
                    "5ce2802b22035d4c3d05bf97",
                    "5ce2805922035d4c3d05bf9b",
                    "5ce2805b22035d4c3d05bf9c",
                    "5ce2806022035d4c3d05bf9e",
                    "5ce2806022035d4c3d05bf9d",
                    "5ce2806122035d4c3d05bf9f",
                    "5ce2806222035d4c3d05bfa0",
                    "5ce2806422035d4c3d05bfa1",
                    "5ce2806722035d4c3d05bfa2",
                    "5ce2806c22035d4c3d05bfa4",
                    "5ce2806d22035d4c3d05bfa5",
                    "5ce2806c22035d4c3d05bfa3",
                    "5ce2806e22035d4c3d05bfa7",
                    "5ce2806e22035d4c3d05bfa6",
                    "5ce2806f22035d4c3d05bfa8",
                    "5ce2807022035d4c3d05bfa9",
                    "5ce2807122035d4c3d05bfaa",
                    "5ce280b322035d4c3d05bfb3",
                    "5ce280b222035d4c3d05bfb1",
                    "5ce280b222035d4c3d05bfb2",
                    "5ce280b522035d4c3d05bfb4",
                    "5ce280b622035d4c3d05bfb5",
                    "5ce280b922035d4c3d05bfb8",
                    "5ce280be22035d4c3d05bfba",
                    "5ce280c822035d4c3d05bfbb",
                    "5ce280d022035d4c3d05bfbc",
                    "5ce280d222035d4c3d05bfbd",
                    "5ce280d522035d4c3d05bfbf",
                    "5ce280d622035d4c3d05bfc0",
                    "5ce280d722035d4c3d05bfc1",
                    "5ce280d822035d4c3d05bfc2",
                    "5ce280d922035d4c3d05bfc3",
                    "5ce280d922035d4c3d05bfc4",
                    "5ce2811922035d4c3d05bfca",
                    "5ce2811922035d4c3d05bfcb",
                    "5ce2811a22035d4c3d05bfcc",
                    "5ce2811922035d4c3d05bfc9",
                    "5ce2811b22035d4c3d05bfcd",
                    "5ce2811e22035d4c3d05bfce",
                    "5ce2812022035d4c3d05bfcf",
                    "5ce2813122035d4c3d05bfd1",
                    "5ce2813322035d4c3d05bfd3",
                    "5ce2813322035d4c3d05bfd4",
                    "5ce2813322035d4c3d05bfd2",
                    "5ce2813622035d4c3d05bfd5",
                    "5ce2813a22035d4c3d05bfd6",
                    "5ce2813a22035d4c3d05bfd7",
                    "5ce2813d22035d4c3d05bfd8",
                    "5ce2813e22035d4c3d05bfd9",
                    "5ce2817022035d4c3d05bfdc",
                    "5ce2817122035d4c3d05bfdd",
                    "5ce2817722035d4c3d05bfde",
                    "5ce2817b22035d4c3d05bfdf",
                    "5ce2817c22035d4c3d05bfe0",
                    "5ce2817d22035d4c3d05bfe2",
                    "5ce2817c22035d4c3d05bfe1",
                    "5ce2817e22035d4c3d05bfe3",
                    "5ce2818322035d4c3d05bfe4",
                    "5ce2818422035d4c3d05bfe5",
                    "5ce2818622035d4c3d05bfe6",
                    "5ce2818b22035d4c3d05bfe8",
                    "5ce2818b22035d4c3d05bfe7",
                    "5ce2818c22035d4c3d05bfe9",
                    "5ce2821d22035d4c3d05bff1",
                    "5ce2821e22035d4c3d05bff2",
                    "5ce2825d22035d4c3d05bffb",
                    "5ce2826d22035d4c3d05bffc",
                    "5ce2827822035d4c3d05bffd",
                    "5ce2827b22035d4c3d05c001",
                    "5ce2827822035d4c3d05bffe",
                    "5ce2827822035d4c3d05bfff",
                    "5ce2827822035d4c3d05c000",
                    "5ce2828522035d4c3d05c005",
                    "5ce2827b22035d4c3d05c002",
                    "5ce2828922035d4c3d05c006",
                    "5ce2828222035d4c3d05c004",
                    "5ce2828922035d4c3d05c007",
                    "5ce2829722035d4c3d05c00b",
                    "5ce2828e22035d4c3d05c00a",
                    "5ce2828e22035d4c3d05c009",
                    "5ce2828e22035d4c3d05c008",
                    "5ce2831722035d4c3d05c011",
                    "5ce2832b22035d4c3d05c012",
                    "5ce2833222035d4c3d05c014",
                    "5ce2832f22035d4c3d05c013",
                    "5ce2833b22035d4c3d05c015",
                    "5ce2834222035d4c3d05c016",
                    "5ce2834622035d4c3d05c017",
                    "5ce2834722035d4c3d05c018",
                    "5ce2834922035d4c3d05c019",
                    "5ce2834c22035d4c3d05c01a",
                    "5ce2834e22035d4c3d05c01c",
                    "5ce2834e22035d4c3d05c01b",
                    "5ce2835222035d4c3d05c01d",
                    "5ce2835522035d4c3d05c01e",
                    "5ce2835822035d4c3d05c01f",
                    "5ce2838d22035d4c3d05c023",
                    "5ce2838d22035d4c3d05c022",
                    "5ce2839e22035d4c3d05c024",
                    "5ce283a122035d4c3d05c025",
                    "5ce283a322035d4c3d05c026",
                    "5ce283a422035d4c3d05c027",
                    "5ce283ab22035d4c3d05c028",
                    "5ce283ae22035d4c3d05c029",
                    "5ce283b122035d4c3d05c02a",
                    "5ce283b322035d4c3d05c02b",
                    "5ce283b322035d4c3d05c02d",
                    "5ce283b322035d4c3d05c02c",
                    "5ce283b622035d4c3d05c02e",
                    "5ce283b722035d4c3d05c02f",
                    "5ce283b822035d4c3d05c031",
                    "5ce283b822035d4c3d05c030",
                ],
                primaryImages: [
                    {
                        _id: "5ce283a422035d4c3d05c027",
                        tags: [],
                        name: "suchita-corporate-party-at-southpoint-carnival-6cngf",
                        baseUrl: "suchita-corporate-party-at-southpoint-carnival",
                    },
                    {
                        _id: "5ce2802b22035d4c3d05bf98",
                        tags: [],
                        name: "suchita-corporate-party-at-southpoint-carnival-9rp8g",
                        baseUrl: "suchita-corporate-party-at-southpoint-carnival",
                    },
                    {
                        _id: "5ce2802522035d4c3d05bf91",
                        tags: [],
                        name: "suchita-corporate-party-at-southpoint-carnival-uwp7h",
                        baseUrl: "suchita-corporate-party-at-southpoint-carnival",
                    },
                ],
                isApproved: true,
                infoComplete: 0,
                uploadCount: 202,
                event_id: "",
                url: "suchita-corporate-party-at-southpoint-carnival",
                venue_id: "5aa911b8b78e580019e45c3c",
                venue_name: "Southpoint Carnival",
                event_name: "Suchita Corporate Party",
                customer_name: "Suchita",
                color: [
                    {
                        _id: "5af3d642d406dc0053263dac",
                        name: "Red",
                        code: "#C00707",
                    },
                    {
                        _id: "5af3d62bd406dc0053263dab",
                        name: "White",
                        code: "#F3F3F3",
                    },
                    {
                        _id: "5af3d680d406dc0053263dad",
                        name: "Yellow",
                        code: "#F1F40E",
                    },
                ],
                customer_review: "",
                description: "",
                event_date: "2019-05-16T18:30:00.000Z",
                event_time: "Dinner",
                event_type: "Corporate Party",
                guests: 380,
                name: "Suchita Corporate Party",
                city: "gurgaon",
                loc: {
                    long: 77.0990132,
                    lat: 28.4481452,
                },
                subArea: "Golf Course Road",
                venue_address: "1st Floor, Southpoint Mall, Golf Course Road, Gurgaon.",
                venue_type: "Bar and Pub",
                vendor_address: "",
                vendor_name: "",
                publicImageCount: 196,
            },
        ],
    },
    isCorporateHeaderVisible: false,
    isCorporateLeadSubmitting: false,
    isOnline: true,
    isCorporateUserRegistered: false,
    defaultWhatsAppContact: contactDetails.default_agent_contact,
    agentCityContacts: contactDetails.city_agent_contact,
    WHATSAPP_PHONE_NO: contactDetails.whatsapp_phone_number,
    CALL_PHONE_NO: `+91${contactDetails.phone_number}`,
    CALL_PHONE_NO_DISPLAY: `${contactDetails.separated_phone_number}`,
    isFetchingCorporateData: false,
    isLoginSuccessModalVisible: false,
    isRegisterSuccessModalVisible: false,
    isWrongOtpEntered: false,
    isResendingLoginOtp: false,
    isAdsBannerVisible:false
};

const AppReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_REDIRECTION_URL : 
        return {
            ...state,
            loginRedirectionUrl:action.loginRedirectionUrl
        }
        case BACK_BUTTON_VISIBILITY_STATUS:
            return {
                ...state,
                isBackButtonVisible: action.isBackButtonVisible,
            };

        case SET_NETWORK_STATUS:
            return {
                ...state,
                isOnline: action.isOnline,
            };

            case IS_ADS_BANNER_VISIBLE:
                return {
                    ...state,
                    isAdsBannerVisible: action.isAdsBannerVisible,
                };            

        case PAGE_NOT_FOUND:
            return {
                ...state,
                isPageNotFound: action.isPageNotFound,
            };

        case SET_HOME_PAGE_FOOTER:
            return {
                ...state,
                isFooterBelowVisible: action.isFooterBelowVisible,
            };

        case PAGE_REDIRECT:
            return {
                ...state,
                isPageRedirect: action.isPageRedirect,
                redirectStatus: action.redirectStatus,
                redirectUrl: action.redirectUrl,
            };

        case REQUEST_LOGIN:
            return {
                ...state,
                isFetching: action.isFetching,
                _refurl: action._refurl,
            };

        case LOGIN_SUCCESS:
            return {
                ...state,
                isAuthenticated: action.isAuthenticated,
                isFetching: action.isFetching,
                message: '',
                user: action.user,
            };

        case LOGIN_FAILURE:
            return {
                ...state,
                isAuthenticated: false,
                isFetching: false,
                message: action.message,
            };

        case REQUEST_OTP_LOGIN:
            return {
                ...state,
                isRequestingOtp: action.isRequestingOtp,
                isOTPSent: action.isOTPSent,
            };

        case REQUEST_OTP_FAILURE:
            return {
                ...state,
                isRequestingOtp: action.isRequestingOtp,
                isOTPSent: action.isOTPSent,
                isResendingLoginOtp: action.resendingLoginOtp,
                message: action.message,
            };

        case REQUEST_OTP_SUCCESS:
            return {
                ...state,
                isRequestingOtp: action.isRequestingOtp,
                isOTPSent: action.isOTPSent,
                message: action.message,
                isResendingLoginOtp: action.resendingLoginOtp
            };
        
        case REQUEST_OTP_FAILURE_MOBILE:
            return {
                ...state,
                isRequestingOtp: action.isRequestingOtp,
                isOTPSent: action.isOTPSent,
                message: action.message,
            };

        case REQUEST_OTP_SUCCESS_MOBILE:
            return {
                ...state,
                isRequestingOtp: action.isRequestingOtp,
                isOTPSent: action.isOTPSent,
                message: action.message,
            };

        case VERIFYING_OTP:
            return {
                ...state,
                isVerifying: action.isVerifying,
            };

        case LOGIN_OTP_SUCCESS:
            return {
                ...state,
                isOtpVerified: action.isOtpVerified,
                isAuthenticated: action.isAuthenticated,
                isFetching: action.isFetching,
                isSideBarShow: true,
                message: '',
                user: action.data,
                isRequestingOtp: action.isRequestingOtp,
                isOTPSent: action.isOTPSent,
                isVerifying: action.isVerifying,
            };

        case SET_LOGIN_OTP_FAILURE:
            return {
                ...state,
                isLoginOtpFailure: action.isLoginOtpFailure
            }

        case LOGIN_OTP_FAILURE:
            return {
                ...state,
                isAuthenticated: false,
                isFetching: false,
                isRequestingOtp: action.isRequestingOtp,
                message: action.message,
                isVerifying: action.isVerifying,
                isLoginOtpFailure: action.isLoginOtpFailure,
            };


        case REQUEST_CHECK_TOKEN:
            return {
                ...state,
                isAuthenticated: action.isAuthenticated,
                isFetching: action.isFetching,
            };

        case TOKEN_VALID:
            return {
                ...state,
                isAuthenticated: action.isAuthenticated,
                isFetching: action.isFetching,
                user: action.data,
            };

        case TOKEN_INVALID:
            return {
                ...state,
                isAuthenticated: action.isAuthenticated,
                isFetching: action.isFetching,
            };

        case REQUEST_LOGOUT:
            return {
                ...state,
                isAuthenticated: action.isAuthenticated,
                isFetching: action.isFetching,
                isVerifying: action.isVerifying,
                isLoginOtpFailure: action.isLoginOtpFailure,
                user: action.user,
            };

        case LOGOUT_SUCCESS:
            return {
                ...state,
                isAuthenticated: false,
                isFetching: false,
                message: action.message,
            };

        case EDIT_USER_INFO:
            return {
                ...state,
                isEditingUserInfo: action.isEditingUserInfo,
            };

        case EDITING_USER_INFO:
            return {
                ...state,
                isSavingUserInfo: action.isSavingUserInfo,
            };

        case CLOSE_EDIT_USER_INFO:
            return {
                ...state,
                isEditingUserInfo: action.isEditingUserInfo,
                isSavingUserInfo: action.isSavingUserInfo,
            };

        case UPDATE_USER_INFO_STATE:
            return {
                ...state,
                user: action.user,
            };

        case LOADING_CAREERS_PAGE:
            return {
                ...state,
                isFetchingJobs: action.isFetchingJobs,
            };

        case LOAD_CAREERS_PAGE:
            return {
                ...state,
                isFetchingJobs: action.isFetchingJobs,
                jobs: action.jobs,
            };

        case CONTACT_SUBMITTING_DATA:
            return {
                ...state,
                isSubmitting: action.isSubmitting,
            };

        case FETCHING_PAGEDATA:
            return {
                ...state,
                isFetchingPagedata: action.isFetchingPagedata,
            };

        case FETCH_PAGEDATA:
            return {
                ...state,
                isFetchingPagedata: action.isFetchingPagedata,
                pagedata: action.pagedata,
                nation: action.nation,
                countryCodeDict: action.countryCodeDict,
            };

        case REQUEST_REGISTER:
            return {
                ...state,
                isRegistering: action.isRegistering,
            };

        case REGISTER_SUCCESS:
            return {
                ...state,
                isRegistering: action.isRegistering,
                isRegisterOTPSent: action.isRegisterOTPSent,
            };

        case REGISTER_FAILURE:
            return {
                ...state,
                isRegistering: action.isRegistering,
                isRegisterOTPSent: action.isRegisterOTPSent,
            };

        case RESET_REGISTER:
            return {
                ...state,
                isRegistering: action.isRegistering,
                isRegisterOTPSent: action.isRegisterOTPSent,
            };

        case LOAD_CITY_LIST:
            return {
                ...state,
                cities: action.cities,
                occasions: action.occasions,
            };

        case TOGGLE_CORPORATE_PAGE_HEADER:
            return {
                ...state,
                isCorporateHeaderVisible: action.isCorporateHeaderVisible,
            };

        case TOGGLE_LEAD_SUBMITTING:
            return {
                ...state,
                isCorporateLeadSubmitting: action.isCorporateLeadSubmitting,
            };

        case CORPORATE_USER_REGISTER_STATUS:
            return {
                ...state,
                isCorporateUserRegistered: action.isCorporateUserRegistered,
            };
        case SET_AUTH_VIEW:
            return {
                ...state,
                authView: action.authView,
            };
        case REGISTER_PAUSE:
            return {
                ...state,
                isRegistering: action.isRegistering,
                isRegisterOTPSent: action.isRegisterOTPSent,
                isOTPSent: action.isOTPSent,
                isRequestOTPDone: action.isRequestOTPDone,
                showOTPSegment: action.showOTPSegment
            };
        case RESET_LOGIN_OTP_FAILURE:
            return {
                ...state,
                isLoginOtpFailure: action.isLoginOtpFailure
            };
        case LOGIN_SUCCESS_MODAL:
            return {
                ...state,
                isLoginSuccessModalVisible: action.payload
            };
        case REGISTER_SUCCESS_MODAL:
            return {
                ...state,
                isRegisterSuccessModalVisible: action.payload
            };
        case RESEND_LOGIN_OTP:
            return {
                ...state,
                isResendingLoginOtp: action.resendingLoginOtp,
                isLoginOtpFailure: action.isLoginOtpFailure
            };
        case ADDING_USER_LOCATION:
            return {
                ...state,
                userCurrentCity: action.userCurrentCity
            };

        default:
            return state;
    }
};
export const getAppPageNotFoundState = state => state.app.isPageNotFound;

//selectors
export const getSubmittingState = state => state.app.isSubmitting;
export const getJobsFetchingState = (state) => state.app.isFetchingJobs;
export const getJobsList = (state) => state.app.jobs;
export const getIsOtpVerified = (state) => state.app.isOtpVerified;

// selector for custom Modal

export const getDrawerModalVisibilityState = state => state.app.isDrawerModalVisible
// Export Reducer
export default AppReducer;
